import {
  SiteFooter,
  SITE_FOOTER_NAV_LINKS_APP,
} from '@veilstream/ui'
import { useLocation } from 'react-router-dom'
import { useRoleAssumption } from '../contexts/RoleAssumptionContext'
import { isPublicRecordingPath } from '../utils/publicRoutes'
import { ROLE_ASSUMED_BG, ROLE_ASSUMED_BORDER } from '../utils/brandStatusColors'

/**
 * App chrome footer — same links/socials as pricing/support/docs.
 * Compact on authenticated shells; brand blue on public legal/login pages.
 */
const Footer: React.FC = () => {
  const { isRoleAssumed } = useRoleAssumption()
  const { pathname } = useLocation()
  const compactAppFooter =
    isPublicRecordingPath(pathname) ||
    !['/tos', '/privacy', '/login'].includes(pathname)

  return (
    <SiteFooter
      variant={compactAppFooter ? 'compact' : 'brand'}
      links={SITE_FOOTER_NAV_LINKS_APP}
      brandBg={isRoleAssumed ? ROLE_ASSUMED_BG : undefined}
      brandBorder={isRoleAssumed ? ROLE_ASSUMED_BORDER : undefined}
    />
  )
}

export default Footer
